//Action Type

export const systemConfigurationTypes = {
    SYSTEMCONFIGURATION: 'SYSTEMCONFIGURATION',
    APPLE_PUSH_NOTIFICATION: 'APPLEPUSHNOTIFICATION',
    ACCOUNTSETTINGS: "ACCOUNTSETTINGS",
    INSTALLERSTATE: "INSTALLERSTATE",
    ARC_DETAILS: "ARC_DETAILS",
    MAIL_DETAILS: "MAILDETAILS"
}